import {
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
} from '@angular/core';

@Component({
  selector: 'mw-form-section-title',
  templateUrl: 'form-section-title.component.html',
  styleUrls: ['./form-section-title.component.scss'],
})
export class MwFormSectionTitleComponent {
  @HostBinding(`class.mw-form-section-title`)
  hasHostClass = true;

  @Input() title: string;
  @Input() isToggleDisabled: boolean;
  @Input() hasToggle: boolean;
  @Input() isHideContent: boolean;
  @Input() foldable: boolean;
  @Output() hideContent = new EventEmitter<boolean>();
}
